/**
 * 층수 표시용 포맷팅 유틸리티
 * -1, -1층 등을 B1로 표시
 */

/**
 * 층수 문자열을 표시용으로 포맷팅
 * - "-1", "-1층" -> "B1"
 * - "B1", "B1층" -> "B1"
 * - "지하1층" -> "B1"
 * - 지상층은 그대로 유지
 * 
 * @param {string} floorStr - 층수 문자열
 * @returns {string} 포맷팅된 층수 문자열
 */
export function formatFloorForDisplay(floorStr) {
  if (!floorStr || typeof floorStr !== 'string') {
    return floorStr || '';
  }

  let str = floorStr.trim();
  if (!str) return '';

  // "-1", "-1층" 같은 음수 표기를 "B1"로 변환
  str = str.replace(/-(\d+)층?/g, 'B$1');
  
  // "지하1층", "지하1" 같은 한글 표기를 "B1"로 변환
  str = str.replace(/지하\s*(\d+)층?/gi, 'B$1');
  
  // "B1층" -> "B1"로 정리 (층 제거)
  str = str.replace(/B(\d+)층/g, 'B$1');
  
  // 복합 층수 처리 (예: "-1,1층" -> "B1,1층")
  if (str.includes(',')) {
    return str.split(',').map(part => formatFloorForDisplay(part.trim())).join(',');
  }
  
  // 슬래시로 구분된 경우 (예: "-1/5층" -> "B1/5층")
  if (str.includes('/')) {
    return str.split('/').map(part => formatFloorForDisplay(part.trim())).join('/');
  }

  return str;
}

